import * as types from './mutation-types'
import * as actions from './actions'
import * as timeUtil from '@/components/helpers/timeUtil.js'

const state = {
  growplanError: '',
  growplanLoading: 0,
  growplan: {},
  plantContainerTypes: [],
}

const getters = {
  growplanError: state => state.growplanError,
  growplanLoading: state => state.growplanLoading,
  growplan: state => state.growplan,
  growplanTypes: state => state.growplanTypes,
  plantContainerTypes: state => state.plantContainerTypes,
  designators: state => state.designators,
}

const mutations = {
  [types.GET_GROWPLAN_REQUEST] (state) {
    state.growplanLoading = true
    state.growplanError = ''
    state.growplan = {}
  },
  [types.GET_GROWPLAN_SUCCESS] (state, growplan) {
    state.growplanLoading = false
    state.growplanError = ''
    if (growplan.ag_growPhases) growplan.growPhases = growplan.ag_growPhases;
    if (growplan.growPhases) {
      growplan.totalDays = growplan.growPhases.reduce((ans, phase) => {
        ans += timeUtil.secondsToDays(phase.endSeconds - phase.startSeconds)
        return ans;
      }, 0)
    }
    state.growplan = growplan
  },
  [types.GET_GROWPLAN_FAILURE] (state, growplanError) {
    state.growplanLoading = false
    state.growplanError = growplanError
    state.growplan = {}
  },
  [types.GET_PLANT_CONTAINER_TYPES_REQUEST] (state) {
    state.growplanLoading = true
    state.growplanError = ''
    state.plantContainerTypes = []
  },
  [types.GET_PLANT_CONTAINER_TYPES_SUCCESS] (state, plantContainerTypes) {
    state.growplanLoading = false
    state.growplanError = ''
    state.plantContainerTypes = plantContainerTypes
  },
  [types.GET_PLANT_CONTAINER_TYPES_FAILURE] (state, growplanError) {
    state.growplanLoading = false
    state.growplanError = growplanError
    state.plantContainerTypes = []
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}
